import * as React from 'react';
import type { SVGProps } from 'react';
const CaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M216.49 104.49L136.49 184.49C135.375 185.609 134.05 186.496 132.592 187.102C131.133 187.708 129.569 188.019 127.99 188.019C126.411 188.019 124.847 187.708 123.388 187.102C121.93 186.496 120.605 185.609 119.49 184.49L39.4901 104.49C37.2357 102.236 35.9692 99.1781 35.9692 95.99C35.9692 92.8019 37.2357 89.7443 39.4901 87.49C41.7444 85.2356 44.8019 83.9692 47.9901 83.9692C51.1782 83.9692 54.2357 85.2356 56.4901 87.49L128 159L199.51 87.48C201.764 85.2256 204.822 83.9592 208.01 83.9592C211.198 83.9592 214.256 85.2256 216.51 87.48C218.764 89.7343 220.031 92.7919 220.031 95.98C220.031 99.1681 218.764 102.226 216.51 104.48L216.49 104.49Z"
      fill="currentColor"
    />
  </svg>
);
export default CaretDown;
